import { Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import MainLayout from './components/MainLayout';
import Account from './pages/Account';
import CustomerList from './pages/CustomerList';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ProductList from './pages/ProductList';
import Register from './pages/Register';
import Settings from './pages/Settings';
import OrderDetails from './pages/OrderDetails';
import PrintOrder from './pages/PrintOrder';
import Logs from './pages/Logs';
import TransactionLogDetails from './components/logs/TransactionLogDetails';
import GroupLoans from './pages/GroupLoans';
import SalaryAdanceLoans from './pages/SalaryAdvance';
import DenisAdmin from './pages/DenisAdmin';
import DashboardNotFoundPage from './components/notFound/DashboardNotFound';
import Users from './pages/Users';
import UserDetails from './pages/UserDetails';
import Loans from './pages/Loans';

const routes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'orders', element: <Orders /> },
      { path: 'loans/group-loans', element: <GroupLoans /> },
      { path: 'loans/salary-advance', element: <SalaryAdanceLoans /> },
      { path: 'account', element: <Account /> },
      { path: 'orders/:id', element: <OrderDetails /> },
      { path: 'orders/print/:id', element: <PrintOrder /> },
      { path: 'loans', element: <Loans /> },
      { path: 'customers', element: <CustomerList /> },
      { path: 'products', element: <ProductList /> },
      { path: 'settings', element: <Settings /> },
      { path: 'logs', element: <Logs /> },
      { path: 'logs/:id', element: <TransactionLogDetails /> },
      { path: 'denisAdmin', element: <DenisAdmin /> },
      { path: 'users', element: <Users /> },
      { path: 'users/:id', element: <UserDetails /> },

      { path: '404', element: <DashboardNotFoundPage /> },
      { path: '*', element: <Navigate to="/app/404" /> },
    ],
  },
];

export default routes;
